export const Projects = [
  {
    imageSrc: '../images/labyrinth.png',
    title: 'Labyrinth game',
    description: 'Designed and created a text-based labyrinth game using redux store and thunks to manage API calls.',
    languages: ['JavaScript', 'React', 'JSX', 'Redux', 'Styled components', 'Pair-programming'],
    githubLink: 'project-labyrinth',
    netlifyLink: 'maze-by-fanny-and-bridget'
  },
  {
    imageSrc: '../images/todo.png',
    title: 'ToDo App',
    description: 'Designed and built a to-do app with Redux by creating slices, reducers and actions from scratch. I also used Material UI for the first time.',
    languages: ['JavaScript', 'React', 'JSX', 'Redux', 'Material UI'],
    githubLink: 'project-todos',
    netlifyLink: 'todo-app-byfanny'
  },
  {
    imageSrc: '../images/quiz.png',
    title: 'Redux Quiz',
    description: 'Created a multiple-choice quiz with Redux, the assignment was to interact with the store using selectors and dispatching actions. This was my first project in Redux.',
    languages: ['JavaScript', 'React', 'JSX', 'Redux', 'Styled components'],
    githubLink: 'project-redux-quiz',
    netlifyLink: 'neon-souffle-d2a8b2'
  },
  {
    imageSrc: '../images/ux-design.png',
    title: 'Collab with UX-designer',
    description: 'I was given a design hand-off from UX-design student Linnéa Rådahl. The assignment was to transform that design into code with React.',
    languages: ['HTML', 'CSS', 'JavaScript', 'React', 'JSX', 'Styled components'],
    githubLink: 'project-design-handoff',
    netlifyLink: 'fictious-gym-developedbyfanny'
  },
  {
    imageSrc: '../images/movies.png',
    title: 'Movies',
    description: 'Created a movie site with multiple pages using React Router and APIs combining useState with useEffect.',
    languages: ['HTML', 'CSS', 'JavaScript', 'React', 'JSX', 'Pair-programming'],
    githubLink: 'project-movies',
    netlifyLink: 'movie-releases-by-fanny-and-fiona'
  },
  {
    imageSrc: '../images/happy-thoughts.png',
    title: 'Happy Thoughts',
    description: 'Created a Twitter-inspired product, but with less negativity, using React state and fetching/posting data to an API.',
    languages: ['HTML', 'CSS', 'JavaScript', 'React', 'JSX'],
    githubLink: 'project-happy-thoughts',
    netlifyLink: 'happy-thoughts-byfanny'
  },
  {
    imageSrc: '../images/survey.png',
    title: 'Survey',
    description: 'Made a survey design and created a Typeform-like product using React state and controlled form.',
    languages: ['HTML', 'CSS', 'JavaScript', 'React', 'JSX'],
    githubLink: 'project-survey',
    netlifyLink: 'green-survey'
  },
  {
    imageSrc: '../images/music-releases.png',
    title: 'Music releases',
    description: 'Followed a design and created components using React to build a page which shows new albums and single releases by using data from Spotify. Created an extra component to show playlists in a sidebar. This was my first project in React.',
    languages: ['HTML', 'CSS', 'JavaScript', 'React', 'JSX', 'Pair-programming'],
    githubLink: 'project-music-releases',
    netlifyLink: 'extraordinary-macaron-fce4c5'
  },
  {
    imageSrc: '../images/weather-app.png',
    title: 'Weather app',
    description: 'Followed a design and built a simple weather dashboard that tells todays weather, temperature and a 5-day forecast using a weather API.',
    languages: ['HTML', 'CSS', 'JavaScript', 'Pair-programming'],
    githubLink: 'project-weather-app',
    netlifyLink: 'weather-app-byannafannyfiona'
  },
  {
    imageSrc: '../images/guess-who.png',
    title: 'Guess who the game',
    description: 'Created a digital version of the classic board game Guess who.',
    languages: ['HTML', 'CSS', 'JavaScript', 'Pair-programming'],
    githubLink: 'project-guess-who',
    netlifyLink: 'guess-who-byfannystenberg'
  },
  {
    imageSrc: '../images/chatbot.png',
    title: 'Chatbot built in JS',
    description: 'Built a chatbot that gives you recommendations for restaurants in Stockholm depending on your pick of cuisine. This was my first project in JavaScript.',
    languages: ['HTML', 'CSS', 'JavaScript', 'Pair-programming'],
    githubLink: 'project-chatbot',
    netlifyLink: 'theguide-chatbot'
  }
];